'use es6';

import { LAYOUT_WIDGET_DELETE, LAYOUT_WIDGET_DELETE_CONFIRM, LAYOUT_WIDGET_DELETE_REVERT } from 'DesignData/actions/ActionTypes';
import { createOptimisticContentMutatingWidgetActions } from 'DesignData/actions/unifiedLayouts/OptimisticContentOverriddenMutationsFactory';
export const {
  /**
   * Delete a widget.
   *
   * @param {String|Number} layoutId - Id of layout with widget.
   * @param {String}        widgetId - Id of widget to delete.
   */
  mutateWidget: deleteWidget,

  /**
   * Delete multiple widgets.
   *
   * @param {String|Number}   layoutId - Id of layout.
   * @param {Array.<String>}  widgetIds - Ids of widgets to delete.
   */
  mutateMultipleWidgets: deleteMultipleWidgets,

  /**
   * Delete selected widgets.
   *
   * @param {String|Number}   layoutId - Id of layout.
   */
  mutateSelectedWidgets: deleteSelectedWidgets,

  /**
   * Hard deletes widgets without a confirmation.
   *
   * @param {String}          layoutId
   * @param {Array.<String>}  widgetIds
   */
  hardMutateWidgets: hardDeleteWidgets,

  /**
   * Stages widget changes for user confirmation.
   *
   * @param {Number|String}   layoutId
   * @param {Array.<String>}  widgetIds
   */
  stageWidgetsForMutatingConfirmation: stageWidgetsForDeleteConfirmation,

  /**
   * Unstages widget changes for user confirmation.
   *
   * @param {Number|String}   layoutId
   */
  unstageWidgetsForMutatingConfirmation: unstageWidgetsForDeleteConfirmation
} = createOptimisticContentMutatingWidgetActions({
  hardActionType: LAYOUT_WIDGET_DELETE,
  optimisticConfirmationActionType: LAYOUT_WIDGET_DELETE_CONFIRM,
  revertConfirmationActionType: LAYOUT_WIDGET_DELETE_REVERT
});